import { Button } from "@/components/ui/button";
import { WHATSAPP_LINK } from "@/lib/whatsapp";
import heroBg from "@/assets/hero-bg.jpg";

const Hero = () => {
  return (
    <section 
      id="inicio"
      className="relative min-h-[600px] sm:min-h-[650px] md:min-h-[700px] flex items-center justify-center text-center px-4 py-20 sm:py-24 md:py-28 bg-cover bg-[position:50%_20%] sm:bg-[position:50%_25%] md:bg-[position:50%_30%] lg:bg-[position:50%_35%]"
      style={{
        backgroundImage: `url(${heroBg})`,
      }}
    >
      <div className="absolute inset-0 bg-primary/75" aria-hidden="true" />
      <div className="max-w-4xl mx-auto space-y-6 sm:space-y-8 relative z-10">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground leading-tight drop-shadow-lg uppercase">
          <span className="block mb-3 sm:mb-4">Controle de pragas em</span>
          <span className="text-accent bg-primary-foreground/10 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg inline-block mb-3 sm:mb-4">
            Pernambuco
          </span>
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl block mt-3 sm:mt-4">
            EW Saúde Ambiental
          </span>
        </h1>
        
        <div className="space-y-3 sm:space-y-4">
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-primary-foreground font-semibold drop-shadow-md">
            Há mais de 10 anos garantindo ambientes saudáveis
          </p>
          <p className="text-base sm:text-lg md:text-xl text-primary-foreground/95 max-w-2xl mx-auto leading-relaxed">
            Com dedetização segura e eficaz. Mais de 3.000 clientes satisfeitos! 
            Peça seu orçamento e viva livre das pragas hoje mesmo!
          </p>
        </div>
        <Button 
          variant="cta" 
          size="lg"
          asChild
          className="text-base sm:text-lg md:text-xl px-8 sm:px-10 md:px-12 py-5 sm:py-6 h-auto hover-scale shadow-[var(--shadow-strong)] animate-pulse touch-manipulation w-full sm:w-auto max-w-md mx-auto"
        >
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">🚀 Solicitar Orçamento Rápido</a>
        </Button>
      </div>
    </section>
  );
};

export default Hero;
